import React, { lazy, Suspense, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";

const AddNomenclatureStepModal = lazy(() =>
  import("src/features/Modal").then((modal) => ({
    default: modal.AddNomenclatureStepModal,
  }))
);

export default function AddNomenclatureStepButton() {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <Button
        icon={<PlusOutlined />}
        type="default"
        onClick={() => setOpen(true)}
      >
        Добавить номенклатуру по шагам
      </Button>
      {isOpen ? (
        <Suspense fallback={<div></div>}>
          <AddNomenclatureStepModal isOpen={isOpen} setOpen={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}

